// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"96ba9333c91e2a9ea480","9249":"2cbbf12a20c6554f7c6d"}[chunkId] + ".chunk.js";
};